import { render, staticRenderFns } from "./DNNProfileTable.vue?vue&type=template&id=27a858fb&scoped=true&"
import script from "./DNNProfileTable.vue?vue&type=script&lang=js&"
export * from "./DNNProfileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a858fb",
  null
  
)

export default component.exports